import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, MessageCircleIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { usePortal } from '../../contexts/PortalContext';
export function AskQuestion({
  name
}: {
  name: string;
}) {
  const {
    sendMessage
  } = usePortal();
  const [open, setOpen] = useState(false);
  const [text, setText] = useState('');
  const [sent, setSent] = useState(false);
  return <div className="mt-6" data-id="element-581" data-mp="hcw4g5i298te">
      <AnimatePresence mode="wait" initial={false} data-id="element-582" data-mp="cfmfeqyl2z63">
        {sent ? <motion.p key="sent" initial={{
        opacity: 0,
        y: 4
      }} animate={{
        opacity: 1,
        y: 0
      }} className="flex items-center gap-2 text-sm text-positive-700" data-id="element-583" data-mp="ciibe9qvfdrw">
            <CheckIcon className="h-4 w-4" aria-hidden data-id="element-584" data-mp="3gslj8cn0mw8" /> Sent to {name}. Replies usually arrive within a few hours.
          </motion.p> : open ? <motion.div key="form" initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="overflow-hidden" data-id="element-585" data-mp="1xtrysutjp50c">
            <label htmlFor="ask" className="mb-1.5 block text-sm font-medium text-ink-700" data-id="element-586" data-mp="ms3bhjcegc46">
              Your question for {name}
            </label>
            <textarea id="ask" value={text} onChange={e => setText(e.target.value)} rows={3} placeholder="e.g. My bank only offers a PDF for the whole quarter — is that okay?" className="w-full resize-none rounded-xl bg-white p-3.5 text-[15px] ring-1 ring-inset ring-ink-200 placeholder:text-ink-400 focus:outline-none focus:ring-2 focus:ring-pulse-600" data-id="element-587" data-mp="8twowzcwhyjt" />
            <div className="mt-2 flex gap-2" data-id="element-588" data-mp="rrps82rfsahq">
              <Button size="sm" disabled={!text.trim()} onClick={() => {
            sendMessage(text.trim());
            setSent(true);
          }} data-id="element-589" data-mp="rqod9n7av3uq">
                Send
              </Button>
              <Button size="sm" variant="ghost" onClick={() => setOpen(false)} data-id="element-590" data-mp="1oa44hmzvg7nv">
                Cancel
              </Button>
            </div>
          </motion.div> : <motion.button key="btn" onClick={() => setOpen(true)} className="inline-flex items-center gap-2 text-sm font-medium text-pulse-700 hover:underline" data-id="element-591" data-mp="1u2y0el8nh2gq">
            <MessageCircleIcon className="h-4 w-4" aria-hidden data-id="element-592" data-mp="1p6h7ldqi9zxb" /> Have a question? Ask {name}
          </motion.button>}
      </AnimatePresence>
    </div>;
}